export const convertSvgToBase64 = async (url: string): Promise<string> => {
  const response = await fetch(url);
  const svgText = await response.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(svgText, 'image/svg+xml');
  const svgElement = doc.documentElement;

  const width = svgElement.getAttribute('width') || '300';
  const height = svgElement.getAttribute('height') || '150';

  const canvas = document.createElement('canvas');
  canvas.width = parseInt(width, 10);
  canvas.height = parseInt(height, 10);

  const ctx = canvas.getContext('2d');
  const img = new Image();

  const svgBlob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
  const svgUrl = URL.createObjectURL(svgBlob);

  return new Promise<string>((resolve, reject) => {
    img.onload = () => {
      ctx!.drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(svgUrl);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = reject;
    img.src = svgUrl;
  });
};

export const convertPngToBase64 = async (url: string): Promise<string> => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
